import React from 'react';
import Attribution from '../views/attribution/Attribution';

const AttributionContainer = (props) => {
	return (<Attribution />);
}

export default AttributionContainer;



// WEBPACK FOOTER //
// ./src/react/containers/AttributionContainer.jsx